export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 100 100" fill="none" className={className} aria-hidden="true">
    <circle cx="50" cy="50" r="40" stroke="#FF5500" strokeWidth="14" />
    <path
      d="M30 66V36l20 18 20-18v30"
      stroke="#F8FAFC"
      strokeWidth="9"
      fill="none"
    />
  </svg>
);

export const LogoLockup = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className={compact ? "w-8 h-8" : "w-10 h-10"} />
    <span className="leading-none">
      <span className="font-display tracking-wide text-xl sm:text-2xl uppercase block text-white font-extrabold">
        Motion Tyres
      </span>
      {!compact && (
        <span className="font-telemetry text-[10px] tracking-[0.3em] uppercase text-[#FF5500] block mt-1">
          Services · 24/7 Mobile
        </span>
      )}
    </span>
  </span>
);
